module.exports = __webpack_public_path__ + "static/hymots-yatay2-514f54c6452b9d2908c374ef32a69001.png";